import { Component, OnInit } from '@angular/core';
import { MemberQuery } from '@fgb/core';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'fgb-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent implements OnInit {
  memberData$: Observable<{ name: string; memberId: string }>;
  constructor(private memberQuery: MemberQuery) {}

  ngOnInit(): void {
    this.memberData$ = this.memberQuery.selectMemberDetails().pipe(
      map((m) => ({
        name: m?.FirstName ?? '',
        memberId: m?.MemberId ?? '',
      }))
    );
  }
}
